module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('blog-header'), _vm._v(" "), _c('el-input', {
    staticClass: "title-input",
    attrs: {
      "placeholder": "请输入标题"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('el-select', {
    attrs: {
      "slot": "prepend",
      "filterable": "",
      "allow-create": "",
      "placeholder": "分类"
    },
    slot: "prepend",
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "size": "large",
      "icon": "upload"
    },
    on: {
      "click": _vm.handleCommitCtx
    },
    slot: "append"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "editor"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0fd9e73c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/Editor.vue
// module id = 179
// module chunks = 1